module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image04-415x415.e42310f7.jpg";